/**
 * Users Sagas
 */
import { call, put, select } from 'redux-saga/effects'
import { getUsers, activateUser, deactivateUser, orgIdUrl } from 'api'
import {
  tokenSelector,
  makeSelectIsMtiAdmin,
  makeSelectMtiPermissionAnyResource,
} from '../App/selectors'
import {
  fetchUsersPending,
  fetchUsersFulfilled,
  fetchUsersFailed,
} from './actions'
import { usersSelector, loadingSelector } from './selectors'
import { errorToast, successToast } from '../../utils/utils'

export function* loadUsersData({ payload = {} } = {}) {
  const {
    query: {
      page,
      per,
      attribute,
      direction,
      filters,
    } = {
      page: 1,
      per: 20,
      attribute: '',
      direction: 'asc',
      filters: [],
    },
    withInactive,
  } = payload
  const token = yield select(tokenSelector)
  const data = yield call(
    getUsers,
    token,
    attribute,
    direction,
    undefined,
    undefined,
    withInactive,
    page,
    per,
    filters,
  )

  return data
}

export function* loadUsers({ payload = {} } = {}) {
  const listUsersPermissionData = yield select(
    makeSelectMtiPermissionAnyResource('User: Index (list) Records')
  )
  if (!listUsersPermissionData) {
    return
  }

  const token = yield select(tokenSelector)
  if (!token) {
    console.log('Skipping get Users')
    return
  }
  const isMtiAdmin = yield select(makeSelectIsMtiAdmin())
  if (isMtiAdmin && !orgIdUrl()) return
  const isFetchUsersPending = yield select(loadingSelector)
  if (isFetchUsersPending) return
  const usersLoaded = yield select(usersSelector)
  const isUsersLoaded = usersLoaded && usersLoaded.length > 0
  try {
    if (!isUsersLoaded) {
      yield put(fetchUsersPending())
    }

    const data = yield call(loadUsersData, { payload })
    yield put(fetchUsersFulfilled(data))
  } catch (error) {
    console.error(error)
    yield put(fetchUsersFailed(error))
    errorToast('Load Users failed')
  }
}

export function* changeUserStatus({ payload: { user, newStatus, showInactiveUsersOnReload } }) {
  const token = yield select(tokenSelector)
  if (newStatus == 'active') {
    try {
      yield call(activateUser, token, user.id)
    } catch (e) {
      errorToast('Unable to activate user.')
      return console.log(e)
    }
    successToast('Successfully activated user.')
  } else if (newStatus == 'inactive') {
    try {
      yield call(deactivateUser, token, user.id)
    } catch (e) {
      errorToast('Unable to deactivate user.')
      return console.log(e)
    }
    successToast('Successfully deactivated user.')
  } else { return } // we don't currently support manually changing to any other status

  // reload users to refresh users page
  yield call(loadUsers, { payload: { withInactive: showInactiveUsersOnReload } })
}
